/* eslint-disable prefer-template */
/* eslint-disable default-param-last */
import { actionType } from 'Config/actionTypes';

const INITIAL_STATE = {
  data: [],
  isLoading: false,
  isError: false,
  msgError: '',
  showSurvey: false,
  errMessage: '',
  statusCode: '',
};
export const lastUpdateReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionType.LAST_UPDATE + '_LOADING':
      return {
        ...state,
        isLoading: true,
      };
    case actionType.LAST_UPDATE + '_RESULT':
      return {
        ...state,
        data: action.result.data,
        isLoading: false,
        isError: false,
        msgError: '',
      };

    case actionType.LAST_UPDATE + '_FAILED':
      return {
        ...state,
        isError: true,
        msgError: action.err,
        isLoading: false,
      };
    case actionType.SHOW_SURVEY + '_RESULT':
      return {
        ...state,
        showSurvey: action?.result?.data?.is_show,
      };
    case actionType.ERROR_STATUS:
      return {
        ...state,
        errMessage: action?.err,
        statusCode: action?.status,
      };
    default:
      return state;
  }
};
